import type { PartialMessages } from "../messages";

export const ko: PartialMessages = {
  "status.syncing": "동기화됨", "status.connecting": "연결 중", "status.full": "가득 참", "status.closed": "연결 끊김",
  "toast.connecting": "연결 중…", "toast.reconnecting": "연결이 끊겼습니다. 다시 연결 중…",
  "toast.retrying": "잠시 후 다시 시도합니다.", "toast.busy": "지금 혼잡합니다",
  "notice.mapChanged": "{name} 님이 맵을 바꿨습니다",
  "hint.place": "클릭해서 놓고, 그대로 끌어서 방향 지정 (Esc로 취소)",
  "kind.objective": "목표", "kind.rally": "집결", "kind.enemy": "적", "kind.loot": "전리품",
  "kind.extract": "탈출", "kind.danger": "위험", "kind.self": "내 위치", "kind.ping": "여기!",
  "hint.objective": "어디로 갈지", "hint.rally": "모일 지점",
  "hint.enemy": "본 방향으로 돌려서 놓기", "hint.loot": "희귀 컨테이너, 시체",
  "hint.extract": "사용할 탈출구", "hint.danger": "지뢰, 저격수, 개활지",
  "hint.self": "내 현재 위치. 다시 놓으면 이전 것은 사라집니다",
  "hint.ping": "25초 뒤 자동으로 사라지는 임시 표시",
  "tool.clearMine": "내 것 지우기", "tool.clearMineHint": "내가 놓은 핀을 모두 지웁니다",
  "sidebar.map": "맵 (모두에게 적용)", "sidebar.styleSvg": "일러스트", "sidebar.styleTile": "위성",
  "sidebar.floors": "층 (내 화면만 바뀝니다)", "sidebar.groundFloor": "지상",
  "sidebar.floorNote": "다른 층에 놓인 핀은 흐리게 표시됩니다.",
  "sidebar.members": "{count}명", "sidebar.you": "나", "sidebar.guest": "게스트",
  "sidebar.clearAll": "모두의 핀 지우기", "sidebar.openWindow": "별도 창으로 열기 (나만)",
  "sidebar.invite": "초대하기", "sidebar.help": "사용법", "sidebar.feedback": "의견 보내기",
  "sidebar.mapData": "지도 데이터", "sidebar.license": "라이선스", "sidebar.licenseNote": "비영리 사용에 한함",
  "sidebar.room": "방",
  "pin.facing": "방향", "pin.floor": "층", "pin.map": "맵", "pin.noFacing": "방향 없음",
  "pin.facingValue": "{compass} ({degrees}°)",
  "pin.notePlaceholder": "메모 남기기 (예: 3층 창문)",
  "pin.removeMine": "이 핀 삭제", "pin.removeOther": "다른 사람의 핀 삭제", "pin.close": "닫기",
  "compass.n": "북", "compass.ne": "북동", "compass.e": "동", "compass.se": "남동",
  "compass.s": "남", "compass.sw": "남서", "compass.w": "서", "compass.nw": "북서",
  "handoff.title": "별도 창으로 열기",
  "handoff.lede": "나를 위한 링크입니다. 같은 방을 브라우저에서 열어, Discord에서는 화면 공유를 계속 보면서 지도는 다른 화면에 둘 수 있습니다.",
  "handoff.open": "이 PC의 브라우저에서 열기", "handoff.or": "다른 기기에서 열려면",
  "handoff.codeHint": "그 기기에서 {host}/j/ 에 접속한 뒤 위 코드를 입력하세요.",
  "handoff.copy": "링크 복사", "handoff.copied": "복사했습니다",
  "handoff.copyFailed": "위 칸을 선택했습니다 — Ctrl+C를 누르세요",
  "handoff.expiry": "이 링크는 한 번만 사용할 수 있습니다. {time} 후 만료됩니다.",
  "handoff.warn": "다른 사람에게 줄 수 없습니다(열면 소진됩니다). 사람을 부를 때는 「초대하기」를 쓰세요.",
  "handoff.creating": "링크를 만드는 중…", "handoff.failed": "링크를 만들지 못했습니다",
  "invite.title": "초대하기",
  "invite.lede": "음성 채널에 없는 사람을 이 지도로 부를 수 있습니다. 링크를 연 사람은 이름을 입력하고 핀을 놓을 수 있습니다.",
  "invite.copy": "링크 복사", "invite.warn": "이 링크를 아는 사람은 누구나 참여할 수 있습니다. 공개된 곳에 올리지 마세요.",
  "invite.budget": "{left}명 더 참여 가능, {time} 후 만료 (사용 {used}/{max}).",
  "invite.revoke": "이 링크를 지금 무효화", "invite.revoked": "링크를 무효화했습니다.",
  "invite.creating": "링크를 만드는 중…", "invite.failed": "링크를 만들지 못했습니다",
  "invite.revokeFailed": "무효화하지 못했습니다",
  "join.title": "지도에 참여하기",
  "join.lede": "초대받은 레이드 지도에 들어갑니다. 표시할 이름을 정하세요. 놓은 핀에 이 이름이 표시됩니다.",
  "join.name": "이름", "join.go": "참여", "join.joining": "참여하는 중…", "join.failed": "참여하지 못했습니다",
  "feedback.title": "제작자에게 보내기", "feedback.request": "요청", "feedback.bug": "버그",
  "feedback.other": "기타", "feedback.requestHint": "이렇게 되면 좋겠어요",
  "feedback.bugHint": "이상하거나 작동하지 않아요", "feedback.otherHint": "무엇이든",
  "feedback.placeholder": "예: 화살표뿐 아니라 선도 긋고 싶어요 / Streets에서 층이 바뀌지 않아요",
  "feedback.note": "답변을 위해 Discord 표시 이름과 ID가 함께 전송됩니다.",
  "feedback.send": "보내기", "feedback.sending": "보내는 중…", "feedback.sent": "보냈습니다. 감사합니다.",
  "feedback.failed": "보내지 못했습니다",
  "time.minutes": "약 {n}분", "time.hoursMinutes": "약 {h}시간 {m}분",
  "error.roomFull": "이 방은 가득 찼습니다",
  "error.tooManyWindows": "이 방을 너무 많이 열었습니다. 다른 창을 닫아 주세요.",
  "error.serverFull": "서버가 가득 찼습니다", "error.session": "세션이 유효하지 않습니다. 다시 열어 주세요.",
  "error.handoffSpent": "이 링크는 사용할 수 없습니다. 본인 전용 1회성 링크입니다. 다른 사람을 부르려면 지도의 「초대하기」에서 링크를 만드세요.",
  "error.inviteSpent": "이 초대 링크는 더 이상 사용할 수 없습니다. 새 링크를 받아 주세요.",
  "error.inviteNotOwner": "링크를 만든 사람만 무효화할 수 있습니다",
  "error.noRoom": "방이 지정되지 않았습니다", "error.needName": "이름을 입력해 주세요",
  "error.tooShort": "조금만 더 자세히 써 주세요", "error.tooLong": "너무 깁니다",
  "error.badKind": "잘못된 분류입니다",
  "error.rateLimited": "너무 많이 보냈습니다. 10분쯤 뒤에 다시 시도해 주세요.",
  "error.busy": "혼잡합니다. 잠시 후 다시 시도해 주세요.",
  "error.sendFailed": "보내지 못했습니다. 나중에 다시 시도해 주세요.",
  "error.feedbackClosed": "지금은 접수를 받지 않습니다",
  "error.sessionGone": "원래 세션이 종료되었습니다. 액티비티에서 다시 열어 주세요.",
  "landing.tagline1": "타르코프 맵을",
  "landing.tagline2": "Discord 통화 중에 다 같이 보면서 설명할 수 있습니다.",
  "landing.install": "Discord에 추가",
  "landing.installNote": "무료. 음성 채널의 로켓 아이콘에서 실행합니다.",
  "landing.body": "통화 중인 모두의 화면에 같은 지도가 나옵니다. 클릭하면 핀이 놓이고, 그대로 끌면 방향 화살표가 붙어서 위치뿐 아니라 「어느 쪽으로 갈지」까지 보여 줄 수 있습니다.",
  "landing.point1": "같은 통화에 있기만 하면 같은 지도에 들어갑니다",
  "landing.point2": "전 13개 맵. 일러스트와 위성, 층 전환",
  "landing.point3": "놓은 핀은 남으니 나중에 다시 볼 수 있습니다",
  "landing.point4": "통화에 없는 사람도 초대 링크로 참여할 수 있습니다",
  "landing.footNote": "게임에는 일절 손대지 않습니다. 파일도 메모리도 읽지 않고, 게임 화면에 아무것도 그리지 않습니다. 모든 핀은 사람이 손으로 놓은 것입니다.",
  "landing.footCredit": "개인이 취미로 만들어 무료로 운영합니다. 지도 데이터는 {tarkovdev} (CC BY-NC-SA 4.0). Escape from Tarkov는 Battlestate Games Limited의 제품이며, 이것은 해당 사와 무관한 비공식 팬 제작물입니다.",
  "landing.updates": "업데이트", "landing.allUpdates": "모든 업데이트",
  "boot.connecting": "Discord에 연결 중…", "boot.failedTitle": "시작하지 못했습니다",
};
